
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jak-otrzymac-numer-pesel",
      function () {
        return require("private-next-pages/jak-otrzymac-numer-pesel/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jak-otrzymac-numer-pesel"])
      });
    }
  